export class FolderableMoveStrategy {
    constructor(folderableDirective) {
        this.directive = folderableDirective;
    }
    deleteDragImage() {
        // Delete ghost image to prevent accumulating unused elements in the page.
        const elem = document.getElementById(this.SELECTION_GHOST_IMAGE_ID);
        if (elem) {
            elem.remove();
        }
    }
}
